import React, { Component } from 'react';

import moment from 'moment';

import ModuleBlock from './components/ModuleBlock';

import './PastSessions.scss';

class PastSessions extends Component {
  render() {
    let PreviousSessions = this.props['student-report-data'].PreviousSessions.filter(x => x.scheduled_to !== null);
    PreviousSessions.sort((a, b) => {
      return (new Date(b.scheduled_to)).getTime() - (new Date(a.scheduled_to)).getTime();
    });

    return PreviousSessions.length > 0 ? (
      <div className='past-sessions'>
        <div className='container'>
          <div className='row justify-content-md-center mobile-sticky' style={{ background: '#335788' }}>
            <div className='col text-center'>
              <h2 style={{ padding: '20px', margin: 0 }}>Past Sessions</h2>
            </div>
          </div>
          <div className='row'>
            <div className='col'>
              {PreviousSessions.map((entry, index) => (
                <div className='student-report-learning-roadmap-entry' key={index}>
                  <ModuleBlock module-block-data={entry} />
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    ) : (<div />);
  }
}

export default PastSessions;



// WEBPACK FOOTER //
// ./src/routes/progress-report/routes/ProgressReport/components/ProgressReport/components/PastSessions/index.js